import sharedTranslations from 'messages/shared';
import { AVAILABLE_VIDEO_TYPES } from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';
import renderVideoPlayButtonText, {
  isVisible as isVideoPlayButtonVisible,
  DEFAULT_TRANSLATIONS as VIDEO_PLAY_TRANSLATIONS,
} from '../video/play-button-text';


export const DEFAULT_TRANSLATIONS = {
  ...VIDEO_PLAY_TRANSLATIONS,
  [AVAILABLE_VIDEO_TYPES.FULL]: sharedTranslations.startWatching,
};

/**
 * Is video play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @return {Boolean}
 */
export const isVisible = isVideoPlayButtonVisible;

/**
 * Video play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @param props.translations {Object} see DEFAULT_TRANSLATIONS
 * @return {React.Component}
 */
export default function renderPlayButtonText(props) {
  props.translations = props.translations || DEFAULT_TRANSLATIONS;
  return renderVideoPlayButtonText(props);
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/channel/play-button-text.js